export default "<footer class=\"before-login text-center\">\r\n    <p>Copyright @ 2021 Alafiame All Rights Reserved.</p>\r\n</footer>"